export default function CollapseOne() {
  return (
    <div className="flex flex-col my-2 gap-4">
      <p>Hipersensibilidad a cualquiera de los componentes de la fórmula. Embarazo, lactancia y menores de 18 años. </p>
    </div>
  )
    ;
}